import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconFilterAltOffSvg } from "./IconFilterAltOffSvg.mjs";
const IconFilterAltOff = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconFilterAltOffSvg, ...iconProps });
};
export {
  IconFilterAltOff
};
